import CmWrapBoxEpisodicItem from '../cm-wrap-box-episodic-items/cm-wrap-box-episodic-item.entity';
import { DEPARTMENTS } from '../enums/enums';
import PrWrapBoxEpisodicProp from '../pr-wrap-box-episodic-props/pr-wrap-box-episodic-prop.entity';
import SetWrapBoxSetPiece from '../set-wrap-box-set-pieces/set-wrap-box-set-piece.entity';
import {
	AnyWrapBox,
	AnyWrapBoxInventoryRelation,
	DeptEntityId,
	StorageLocation,
} from '../types';

export interface StorageLocationMap {
	[deptId: number]: { [id: number]: StorageLocation };
}

export function getWrapBoxInventoryLabel(wrapBox: AnyWrapBox): string {
	switch (wrapBox.department) {
		case DEPARTMENTS.CM:
			return 'Costume Items';
		case DEPARTMENTS.PR:
			return 'Props';
		case DEPARTMENTS.SET:
			return 'Set Pieces';
		default:
			return '';
	}
}

interface QuantityInBoxProps {
	cmWrapBoxEpisodicItems: CmWrapBoxEpisodicItem[];
	prWrapBoxEpisodicProps: PrWrapBoxEpisodicProp[];
	setWrapBoxSetPieces: SetWrapBoxSetPiece[];
	inventoryId: number;
	wrapBox: AnyWrapBox;
}

export function getQuantityInBox({
	cmWrapBoxEpisodicItems,
	inventoryId,
	prWrapBoxEpisodicProps,
	setWrapBoxSetPieces,
	wrapBox,
}: QuantityInBoxProps) {
	let relation: AnyWrapBoxInventoryRelation = null;

	switch (wrapBox.department) {
		case DEPARTMENTS.CM:
			relation = cmWrapBoxEpisodicItems.find(
				(r) =>
					r.episodic_item_id === inventoryId && r.cm_wrap_box_id === wrapBox.id
			);
			return relation && relation.quantity !== null ? relation.quantity : null;
		case DEPARTMENTS.PR:
			relation = prWrapBoxEpisodicProps.find(
				(r) =>
					r.episodic_prop_id === inventoryId && r.pr_wrap_box_id === wrapBox.id
			);
			return relation && relation.quantity !== null ? relation.quantity : null;
		case DEPARTMENTS.SET:
			relation = setWrapBoxSetPieces.find(
				(r) =>
					r.set_piece_id === inventoryId &&
					r.set_piece_wrap_box_id === wrapBox.id
			);
			return relation && relation.quantity !== null ? relation.quantity : null;
		default:
			return null;
	}
}

export function parseComplexId(id: string): DeptEntityId {
	const results = id.match(/(\d+)\.(\d+)/);
	if (results !== null) {
		return {
			department: Number(results[1]),
			id: Number(results[2]),
		};
	}
	return null;
}
